"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("./react");

var useTimeout = function useTimeout() {
  var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      ready = _react_1$useState2[0],
      setReady = _react_1$useState2[1];

  react_1.useEffect(function () {
    var timer = setTimeout(function () {
      setReady(true);
    }, ms);
    return function () {
      clearTimeout(timer);
    };
  }, [ms]);
  return ready;
};

exports.default = useTimeout;